import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, initApplicationClickTracking } from "../services/visitorTrackingService";
import { tagPageView } from "../lib/marketingTags";
import { isAdminPath } from "../admin/adminRoutes";

/**
 * Records a page view on first load and on every client-side route change,
 * plus every click through to the Sajili application portal, so the funnel
 * from landing page to started application can be measured end to end.
 * The view is stored first-party (our own dashboard) and mirrored to GA4,
 * Google Tag Manager, PostHog and the ad pixels. Admin screens are excluded so
 * staff activity never inflates visitor numbers.
 */
export default function PageViewTracker() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => initApplicationClickTracking(), []);

  useEffect(() => {
    const path = `${location.pathname}${location.search || ""}`;
    if (isAdminPath(path)) return;
    if (lastPath.current === path) return;
    lastPath.current = path;

    // Let the route render (and set its title) before recording the view.
    const timer = window.setTimeout(() => {
      trackPageView(path, { entry: !document.referrer.includes(window.location.host) });
      tagPageView(path, document.title);
    }, 400);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}
